export const SiteConfiguration = {
  map: {
    dvm: {
      viewer: {
        venueId: 'eu-ch-00005-fclugano',
        mapId: 'blockmap'
        // venue_id: 'eu-ch-00005-fclugano',
        // map_id: 'blockmap'
      },
      minimap: {
        mapId: 'blockmap_minimap',
      }
    },
    styles: {
      section: {
        available: {
          normal: {
            none: {
              fillStyle: '#ffffff',
              strokeStyle: '#ffffff',
              fillOpacity: '0',
              strokeOpacity: '0.7',
              lineWidth: '8',
              // 'opacity': 1,
              // 'cursor': 'auto',
              // 'transition': 'fill 0.5s, fill-opacity 0.5s'
            }
          },
          hover: {
            none: {
              fillStyle: '#ffffff',
              strokeStyle: '#ffffff',
              fillOpacity: 0.7,
              strokeOpacity: 1,
              lineWidth: '8',
              // 'cursor': 'pointer',
              // 'opacity': 1
            }
          }
        },
        selected: {
          normal: {
            none: {
              fillStyle: '#353535',
              strokeStyle: '#ffffff',
              fillOpacity: '1',
              strokeOpacity: 1,
              lineWidth: '8',
              // 'cursor': 'auto',
              // 'opacity': 1
            }
          },
          hover: {
            none: {
              fillStyle: '#ffffff',
              strokeStyle: '#ffffff',
              fillOpacity: '1',
              strokeOpacity: 1,
              lineWidth: '8',
              // 'cursor': 'pointer',
              // 'opacity': 1,
              // 'transition': 'fill 0.5s, fill-opacity 0.5s'
            }
          }
        },
        unavailable: {
          normal: {
            none: {
              fillStyle: '#6d6d6d',
              // 'cursor': 'auto',
              fillOpacity: '0.5',
              // 'opacity': 1
            }
          }
        },
        disabled: {
          normal: {
            none: {
              // 'fillStyle': '#fff',
              // 'cursor': 'auto',
              // 'fillOpacity': 0,
              // 'opacity': 1
            }
          }
        }
      }
    }
  },

  features: {
    externalBtn: {
      link: 'https://www.fclugano.com/',
      text: 'Upcoming Events'
    },
    filters: {
      data: [
        {
          "id": "KCB1B3D",
          "name": "Di Ritrovo",
          "color": "",
          "nodes": { "section": [], "row": [], "seat": [] },
          "parentId": "",
          "mapid": "S_DiRitrovo(INT)R",
          "venueid": "eu-ch-00005-fclugano",
          "type": "vip",
          "mode": "view360",
          "children": []
        },
        {
          "id": "KD3CB13",
          "name": "Tunnel Club",
          "type": "vip",
          "color": "#d49308",
          "mapid": "S_TunnelClub(INT)R",
          "nodes": { "row": [], "seat": [], "section": [] },
          "venueid": "eu-ch-00005-fclugano",
          "parentId": "",
          "mode": "view360",
          "children": []
        },
        {
          "id": "K2B03DB",
          "name": "Lounge",
          "color": "",
          "nodes": { "section": [], "row": [], "seat": [] },
          "parentId": "",
          "mapid": "S_Lounge(INT)R",
          "venueid": "eu-ch-00005-fclugano",
          "type": "vip",
          "mode": "view360",
          "children": []
        },
        {
          "id": "KCAC0C3",
          "name": "First Floor",
          "color": "",
          "nodes": { "section": [], "row": [], "seat": [] },
          "parentId": "",
          "mapid": "S_Firstfloor(INT)R",
          "venueid": "eu-ch-00005-fclugano",
          "type": "vip",
          "mode": "view360",
          "children": []
        },
        {
          "id": "K0BAA2C",
          "name": "Boardroom",
          "color": "",
          "nodes": { "section": [], "row": [], "seat": [] },
          "parentId": "",
          "mapid": "S_Boardroom(INT)R",
          "venueid": "eu-ch-00005-fclugano",
          "type": "vip",
          "mode": "view360",
          "children": []
        }
      ],
      ui: {
        vip: "#FBB03B",
        regular: "#c1c1c1"
      },
    },
    neighbors: {
      data: {
        "S_A1": {
          "l": "S_A2",
          "r": "S_B1"
        },
        "S_A2": {
          "l": "S_A3",
          "r": "S_A1"
        },
        "S_A3": {
          "l": "S_A4",
          "r": "S_A2"
        },
        "S_A4": {
          "l": "S_A5",
          "r": "S_A3"
        },
        "S_A5": {
          "l": "S_A6",
          "r": "S_A4"
        },
        "S_A6": {
          "l": "S_A7",
          "r": "S_A5"
        },
        "S_A7": {
          "l": "S_A8",
          "r": "S_A6"
        },
        "S_A8": {
          "l": "S_A9",
          "r": "S_A7"
        },
        "S_A9": {
          "l": "S_E",
          "r": "S_A8"
        },
        "S_AV": {
          "l": "S_A9",
          "r": "S_A1"
        },
        "S_B1": {
          "l": "S_A1",
          "r": "S_B2"
        },
        "S_B2": {
          "l": "S_B1",
          "r": "S_B3"
        },
        "S_B3": {
          "l": "S_B2",
          "r": "S_B4"
        },
        "S_B4": {
          "l": "S_B3",
          "r": "S_B5"
        },
        "S_B5": {
          "l": "S_B4",
          "r": "S_C1"
        },
        "S_C1": {
          "l": "S_B5",
          "r": "S_C2"
        },
        "S_C2": {
          "l": "S_C1",
          "r": "S_C3"
        },
        "S_C3": {
          "l": "S_C2",
          "r": "S_C4"
        },
        "S_C4": {
          "l": "S_C3",
          "r": "S_C5"
        },
        "S_C5": {
          "l": "S_C4",
          "r": "S_C6"
        },
        "S_C6": {
          "l": "S_C5",
          "r": "S_C7"
        },
        "S_C7": {
          "l": "S_C6",
          "r": "S_D1"
        },
        "S_D1": {
          "l": "S_C7",
          "r": "S_D2"
        },
        "S_D2": {
          "l": "S_D1",
          "r": "S_D3"
        },
        "S_D3": {
          "l": "S_D2",
          "r": "S_E"
        },
        "S_E": {
          "l": "S_D2",
          "r": "S_A9"
        }
      }
    }
  },

  // ui: {
  // },

}